import { QueryKeys } from '@/api/hooks/queryKeys.ts'
import { ApiPaths } from '@/util/paths.ts'
import type { TinderQuestion } from '@/util/views/tinder.ts'
import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

export const useTinderQuestions = () => {
  return useQuery<TinderQuestion[], Error>({
    queryKey: [QueryKeys.TINDER_QUESTION],
    queryFn: async () => {
      const response = await axios.get<TinderQuestion[]>(ApiPaths.TINDER_QUESTION)
      return response.data
    }
  })
}
